module.exports = __webpack_public_path__ + "img/shipo-icon-azure.3c8f034e.svg";